/**
 * 角色常量与权限判断（前端 single source of truth）。
 *
 * 后端真实关卡：apps/users/permissions.py IsInstructorOrAbove.ALLOWED_ROLES
 * 改后端时同步改这里；改这里时同步改后端。
 *
 * 用途：前端 UX 层提示 / 路由权限门 / 导航条目可见性。
 * 不可作为安全边界 —— 后端 DRF Permission 是真实关卡。
 */

export const ROLES = {
  PERSONAL: 'personal',
  INSTRUCTOR: 'instructor',
  ENTERPRISE_ADMIN: 'enterprise_admin',
  ADMIN: 'admin',
  SUPERADMIN: 'superadmin',
};

// 看板可访问角色（与后端 IsInstructorOrAbove 对齐）
export const DASHBOARD_ROLES = [
  ROLES.INSTRUCTOR,
  ROLES.ENTERPRISE_ADMIN,
  ROLES.ADMIN,
  ROLES.SUPERADMIN,
];

// 培训建议可访问角色（与后端 IsEnterpriseAdminOrAbove 对齐, 设计文档 4.3.3 强制覆盖）
export const TRAINING_RECO_ROLES = [
  ROLES.ENTERPRISE_ADMIN,
  ROLES.ADMIN,
  ROLES.SUPERADMIN,
];

// 企业全员看板可访问角色（与后端 IsEnterpriseAdminOrAbove 对齐）
export const ENTERPRISE_DASHBOARD_ROLES = [
  ROLES.ENTERPRISE_ADMIN,
  ROLES.ADMIN,
  ROLES.SUPERADMIN,
];

export function canAccessDashboard(user) {
  return !!user && DASHBOARD_ROLES.includes(user.role);
}

export function canAccessEnterpriseDashboard(user) {
  return !!user && ENTERPRISE_DASHBOARD_ROLES.includes(user.role);
}

export function canAccessTrainingReco(user) {
  return !!user && TRAINING_RECO_ROLES.includes(user.role);
}
